import { Component, AfterViewInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { Doctor as DoctorKyruus } from 'src/app/angular-elements/medical-information/doctor-information-kyruus/configs/interfaces/doctors.interface';
import { Doctor as DoctorSapphireDigital } from 'src/app/angular-elements/medical-information/doctor-information-kyruus/configs/interfaces/doctors.interface';
import { DoctorStateKyruus, DOCTOR_STATE_REDUX_ID_KYRUUS } from 'src/app/angular-elements/medical-information/doctor-information-kyruus/configs/reducers/doctors.reducer';
import { DoctorStateSapphireDigital, DOCTOR_STATE_REDUX_ID_SAPPHIRE_DIGITAL } from 'src/app/angular-elements/medical-information/doctor-information-sapphire-digital/configs/reducers/doctors.reducer';
import { DOCTOR_VENDOR_TYPE } from 'src/app/angular-elements/medical-information/doctor-information/configs/enums/doctor-vendor-type.enum';
import { DoctorVendorTypeState, DOCTOR_VENDOR_TYPE_STATE_REDUX_ID } from 'src/app/angular-elements/medical-information/doctor-information/configs/reducers/doctor-information.reducer';
import { ReducerUtilityService as SXEANGReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';

@FormComponentLookup('form-doctor-information-review')
@Component({
    selector: 'app-form-doctor-information-review',
    templateUrl: './form-doctor-information.component-review.html',
    styleUrls: ['./form-doctor-information.component-review.scss'],
    standalone: false
})
export class FormDoctorInformationReview extends FormEntryComponentClass implements AfterViewInit {

  doctors: (DoctorKyruus | DoctorSapphireDigital)[] = [];

  constructor(private localReducerUtilityService: SXEANGReducerUtilityService) {
    super();
  }

  ngOnInit() {
    const vendorTypeState: DoctorVendorTypeState = this.localReducerUtilityService.getState(DOCTOR_VENDOR_TYPE_STATE_REDUX_ID);
    const vendorType = vendorTypeState.vendorType;
    
    let docState: (DoctorStateKyruus | DoctorStateSapphireDigital) = null;
    
    if (vendorType === DOCTOR_VENDOR_TYPE.SAPPHIRE_DIGITAL) {
      docState = this.localReducerUtilityService.getState(DOCTOR_STATE_REDUX_ID_SAPPHIRE_DIGITAL);
      if (this.entry.custom?.isPcp) {
        if (docState.pcp) {
          this.doctors.push(docState.pcp as DoctorKyruus);
        }
      } else {
        this.doctors = docState.doctors ? docState.doctors as DoctorKyruus[] : [];
      }
    } else if (vendorType === DOCTOR_VENDOR_TYPE.KYRUUS) {
      docState = this.localReducerUtilityService.getState(DOCTOR_STATE_REDUX_ID_KYRUUS);
      if (this.entry.custom?.isPcp) {
        if (docState.pcp) {
          this.doctors.push(docState.pcp as DoctorSapphireDigital);
        }
      } else {
        this.doctors = docState.doctors ? docState.doctors as DoctorSapphireDigital[] : [];
      }
    }

  }

  ngAfterViewInit() { }
}
